import {Component, OnDestroy, OnInit} from '@angular/core';
import {CircleService} from '@shared/services/circle.service';
import {LoaderService} from 'front-base-angular-core/angular/projects/front-base-angular-core/src/public-api';
import {CircleAuthorization} from '@shared/models/circle-authorization.model';
import {LoginService} from '@shared/services/login.service';
import {PatientService} from '@shared/services/patient.service';
import {UserProfile} from '@shared/models/user-profile.model';
import {Subscription} from 'rxjs';
import {patientRoles} from '@shared/constants/patient.constants';

@Component({
  selector: 'si-role-change-page',
  templateUrl: './role-change-page.component.html',
  styleUrls: ['./role-change-page.component.scss']
})
export class RoleChangePageComponent implements OnInit, OnDestroy {
  authorizations: CircleAuthorization[];
  accountUser: UserProfile;
  patientRoles = patientRoles;
  private patientSubscription: Subscription;

  constructor(
    private circleService: CircleService,
    private loaderService: LoaderService,
    private loginService: LoginService,
    private patientService: PatientService
  ) {
  }

  ngOnInit(): void {
    this.getCircleAuthorizations();
    this.patientSubscription = this.patientService.getPatientObservable().subscribe(data => {
      this.accountUser = data.accountUser;
    });
  }

  async getCircleAuthorizations(): Promise<void> {
    try {
      this.loaderService.start();
      this.authorizations = await this.circleService.getAuthorizationsByAccepted();
    } finally {
      this.loaderService.stop();
    }
  }

  async onClickCircleAuthorizedBy(authorizationId: number): Promise<void> {
    await this.selectRole(authorizationId);
  }

  async selectRole(authorizationId: number): Promise<void> {
    try {
      this.loaderService.start();
      await this.loginService.selectRole(authorizationId);
    } finally {
      this.loaderService.stop();
    }
  }

  ngOnDestroy() {
    if (this.patientSubscription) {
      this.patientSubscription.unsubscribe();
    }
  }
}
